module.exports = __webpack_public_path__ + "static/media/nonElectrical.92b1c502.png";